// extracted by mini-css-extract-plugin
export default {"customWidth":"Register_customWidth__OSSrE","defLink":"Register_defLink__vJdfM"};